<div #stickyHeader style="position: sticky; top: 0; z-index: 30; background: #fff; padding: 20px 24px 0;">
  <!-- Zone 1: back + title (left) / active-user avatars, validate,
       download-as-pdf, save (right) -->
  <div class="uk-flex uk-flex-middle uk-flex-between">
    <div class="uk-flex uk-flex-middle" style="gap: 6px; min-width: 0;">
      <ng-content select=".form-top-section"></ng-content>
    </div>
    <div class="uk-flex uk-flex-middle" style="gap: 8px; flex: 0 0 auto;">
      <ng-content select=".form-actions-section"></ng-content>
      @if (downloadPDF) {
        <button class="uk-button uk-button-secondary" (click)="generatePDF()"
          data-uk-tooltip="title:Unsaved changes will not be displayed to pdf; pos: bottom">Download as pdf
        </button>
      }
      <ng-content select=".form-action-bar"></ng-content>
    </div>
  </div>

  <!-- Zone 2: description (left) / section, subsection, field counts (right) -->
  @if (model) {
    <div class="uk-flex uk-flex-middle uk-flex-between" style="margin-top: 8px;">
      <div style="min-width: 0;">
        <ng-content select=".form-notice-section"></ng-content>
      </div>
      <div class="uk-text-meta" style="flex: 0 0 auto; white-space: nowrap; margin-left: 12px;">
        {{ sectionsCount }} sections &middot; {{ subsectionsCount }} subsections &middot; {{ fieldsCount }} fields
      </div>
    </div>
  }

  <!--Chapter Selection-->
  @if (model && ready) {
    <div [ngClass]="{'uk-hidden': (model.sections.length === 1 || !model.sections[0].subSections)}">
      <ul class="uk-tab" style="margin-bottom: 0;" data-uk-tab="connect: #top-navigation-tabs; animation: uk-animation-fade">
        @for (section of model.sections; track section; let i = $index) {
          <li class="">
            @if ((!section.subType || section.subType===subType)) {
              <a (click)="showUnsavedChangesPrompt(section)">
                <span class="uk-badge">{{ String.fromCharCode(65 + i) }}</span>
                {{section.name}}
                @if (section.subSections?.length) {
                  <span class="uk-text-meta">{{ section.subSections.length }}</span>
                }
                @if (chapterChangeMap.get(section.id)) {
                  <span class="material-icons md-10 uk-margin-small-left">circle</span>
                }
                @if (commentsPerSection.get(section.id)) {
                  <span class="uk-flex uk-flex-middle">
                    {{ commentsPerSection.get(section.id) }}
                    <span class="material-symbols-outlined" style="font-size: 18px">chat</span>
                  </span>
                }
              </a>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>

@if (errorMessage) {
  <pre id="errorAlert" class="uk-alert uk-alert-danger" data-uk-alert="duration: 500" style="border-width: 0">
    <a (click)="closeError()" class="uk-alert-close" data-uk-close></a>
    {{ errorMessage }}
  </pre>
}

@if (successMessage) {
  <div id="successAlert" class="uk-alert uk-alert-success" data-uk-alert="duration: 500">
    <p>{{ successMessage }}</p>
  </div>
}

@if (ready) {
  <div>
    <ul id="top-navigation-tabs" class="uk-switcher">
      @for (section of model.sections; let i = $index; track section) {
        <li>
          <app-chapter [form]="getFormGroup(i)" [readonly]="readonly" [validate]="validate"
                       [chapter]="model.sections[i]" [tabsHeader]="tabsHeader"
                       [fields]="model.sections[i].subSections ?? model.sections"
                       [chapterIndex]="i" [sectionsCount]="model.sections.length"
                       [stickyTopOffset]="stickyHeaderHeight()"
                       [mandatoryFieldsText]="mandatoryFieldsText"
                       [editMode]=editMode [enableCommenting]="enableCommenting" [userId]="userId"
                       (totalComments)="setCommentCount($event.sectionId, $event.comments)"
                       (chapterHasChanges)="setChapterChangesMap($event)">
          </app-chapter>
        </li>
      }
    </ul>
  </div>
} @else {
  <i class="loader-big" aria-hidden="true"></i>
}


<div class="uk-position-fixed" style="z-index: 100; top: 90vh; right: 0.4vw">
  <a data-uk-totop style="padding: 18px;" (click)="toTop()"></a>
</div>

<!--<pre *ngIf="form">{{form.value | json}}</pre>-->

<!-- Validation modal -->
<div id="validation-modal" data-uk-modal="esc-close: false; bg-close: false">
  <div class="uk-modal-dialog uk-modal-body">
    <h2 class="uk-modal-title">Survey validation</h2>
    <p>The survey fields will be validated and if all required fields are present it will be locked and it will not be
    editable until unlocked.</p>
    <p class="uk-text-right">
      <button class="uk-button uk-button-secondary uk-modal-close" type="button">Close</button>
      <button class="uk-button uk-button-primary" type="button" (click)="validateForm()">I agree</button>
    </p>
  </div>
</div>

<!-- Unsaved changes modal -->
<div id="unsaved-changes-modal" data-uk-modal="esc-close: false; bg-close: false">
  <div class="uk-modal-dialog uk-modal-body">
<!--    <h2 class="uk-modal-title"></h2>-->
    <p>There are unsaved changes, do you want to submit them before moving on?</p>
    <p class="uk-text-right">
      <button class="uk-button uk-button-secondary uk-modal-close" type="button">I will do it later</button>
      <button class="uk-button uk-button-primary" type="button" (click)="parentSubmit()">Submit now</button>
    </p>
  </div>
</div>
